import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../components/Spinner';
import { useActiveRecordDocuments, useRecordDocumentRequirements } from '../../../../../../../../../../services/record-service';

import DocumentsTable from './components/DocumentsTable';

const DocumentsTableContainer = ({ recordId, insuredId, jobId }) => {
  const { data: documentRequirements, isLoading: docReqsLoading } = useRecordDocumentRequirements(recordId);
  const { data: docs, isLoading: docsLoading } = useActiveRecordDocuments({ recordId });

  const activeDocs = useMemo(() => (docsLoading ? [] : docs), [docs]);

  if (docReqsLoading || docsLoading) {
    return (
      <Flex
        height="100px"
        justifyContent="center"
        position="relative"
      >
        <LoadingSpinner isInline />
      </Flex>
    );
  }

  if (!activeDocs.length && !documentRequirements.length) {
    return (
      <Flex
        alignItems="center"
        color="greyScale.700"
        height="200px"
        justifyContent="center"
      >
        No Documents Requirements
      </Flex>
    );
  }

  return (
    <DocumentsTable insuredId={insuredId} jobId={jobId} recordId={recordId} />
  );
};

DocumentsTableContainer.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default DocumentsTableContainer;
